import { SapExportCompletionMode, SapExportStatus } from "@/api-schema-enums";

export enum SapExportOutcome {
  NotExported = "not-exported",
  ExportedWithMinimalPayload = "exported-with-minimal-payload",
  Exported = "exported",
}

export function getSapExportOutcome(
  exportStatus: SapExportStatus | null | undefined,
  completionMode: SapExportCompletionMode | null | undefined,
): SapExportOutcome {
  if (completionMode === SapExportCompletionMode.UpdateMismatch) {
    return SapExportOutcome.Exported;
  }

  if (exportStatus === SapExportStatus.FAILED) {
    return SapExportOutcome.NotExported;
  }

  if (exportStatus === SapExportStatus.SUCCESS && completionMode === SapExportCompletionMode.MinimalFallback) {
    return SapExportOutcome.ExportedWithMinimalPayload;
  }

  return SapExportOutcome.Exported;
}
